const GIF = require("./gif");
module.exports = GIF;
